import { render, staticRenderFns } from "./MessageAttachment.vue?vue&type=template&id=40e51dee"
import script from "./MessageAttachment.vue?vue&type=script&lang=js"
export * from "./MessageAttachment.vue?vue&type=script&lang=js"
import style0 from "./MessageAttachment.vue?vue&type=style&index=0&id=40e51dee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports